import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import InfiniteScroll from 'react-infinite-scroller';

import { Layout, Row, Col, Collapse, Icon, Badge, List, Skeleton, Avatar, Spin } from "antd";
import Container from "../../../containers/Container";
import messages from '../../../components/Messages'
import message from "../../../components/Messages/";
import BoxChart from './boxChartmb'
import ContainerTotalStatistic from './barmb'

import Api_tnn from '../../../api/api.tnn';
import Api_quantrac from '../../../api/api.quantrac';

const { Panel } = Collapse;
const count = 4;
class DashboardMB extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DoanhNghiep: false,
      loading: false,
      hasMore: true,
      giayPhephData: [],
      tongSoGiayPhepData: [],
    }
  }
  componentDidMount() {
    this.getGiayPhepData(2005, 2020)
  }


  getGiayPhepData(tunam, dennam) {
    new Api_quantrac().Get_API_Dashboard_BieuDoCot({ token: this.props.user.access_token, tunam: tunam, dennam: dennam })
      .then((result) => {
        new Api_tnn().GetTK_BaoCao_BieuDoCot({ token: this.props.user.access_token, tunam: tunam, dennam: dennam })
          .then((res) => {
            if (result && res) {
              let data = []
              result.map((item) => {
                res.map((value) => {
                  let dataBD = {}
                  if (item.năm === value.năm) {
                    dataBD = { ...item, ...value }
                    data.push(dataBD)
                  }
                })
              })
              this.setState({
                giayPhephData: data
              })
            }
          })
      }).catch((err) => {

        message.error(err.message)
      })
  }
  thongke = (tunam, dennam) => {
    this.getGiayPhepData(tunam, dennam)
  }

  componentDidUpdate = () => {

  }

  render() {
    const { giayPhephData, tongSoGiayPhepData } = this.state
    const { functions } = this.props
    return (
        <div>
          <Row style={{ background: "#ced2d83d" }}>
            <Col>
              <div style={{ margin: 10 }} className="solieu">
                <ContainerTotalStatistic data={tongSoGiayPhepData} history={this.props.history} functions={functions} />
                <BoxChart title='Số lượng báo cáo định kỳ theo năm'
                  thongke={this.thongke} data={giayPhephData} history={this.props.history} functions={functions} />
              </div>
            </Col>
          </Row>
        </div>
    )
  }
};

const { Content, Footer } = Layout;

const mapPropsToState = (state) => ({
  user: state.oidc.user,
  functions: state.functions
});
export default connect(mapPropsToState)(DashboardMB)